var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pickup",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "download_1_",
    "data-name": "download (1)",
    transform: "translate(11.419 12.25) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    "data-name": "Path 3187",
    d: "M8.384,6.4l-.629-.716a.478.478,0,0,0-.673-.044L5.206,7.288V.477A.477.477,0,0,0,4.729,0H3.774A.477.477,0,0,0,3.3.477V7.288L1.421,5.644a.478.478,0,0,0-.673.044L.119,6.4a.478.478,0,0,0,.044.675l3.774,3.3a.478.478,0,0,0,.629,0l3.773-3.3A.477.477,0,0,0,8.384,6.4Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.19808f67f4f8683258940b783f88d2cc.svg";
export { ForwardRef as ReactComponent };